var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWomanAtom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "41px",
    viewBox: "0 0 44 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AE459C58-7DDF-434D-A0B3-92F12AD26EF5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "33.-Part-2---Who-can-use-Hana-UI",
    transform: "translate(-362.000000, -711.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(363.000000, 712.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(0.000000, 0.044896)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.32325205
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6717302,29.8891921 C20.6717302,29.8891921 19.4003685,29.6286059 18.9374193,30.1406099 C18.9374193,30.1406099 17.7273053,24.2316279 18.1463036,21.2142351",
    id: "Stroke-1",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9727293,8.05507948 C14.9727293,8.05507948 13.7991938,11.617274 10.7761299,12.2877847",
    id: "Stroke-3",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6189324,0.0505860356 C18.923752,0.0249716566 17.4507834,0.526295149 16.1830134,1.64775126 C15.0370772,2.66136234 14.062313,3.9473743 12.6383993,4.59510618 C12.0319718,4.87100423 11.329703,5.00918955 10.696905,4.80058832 C9.73773625,4.48433108 8.99756576,3.55285615 8.12403037,3.04690128 C6.99264986,2.39179699 5.71580615,1.95540737 4.39510608,2.00446221 C1.79330899,2.10087057 0.0149527482,4.09038004 1.60542828e-05,6.63017332 C-0.0160491571,9.38149789 1.98470795,11.2989846 2.4727044,11.7429357",
    id: "Stroke-5",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66365961,9.61490065 C2.73870642,8.55507027 2.08530346,6.94278216 2.98709973,5.78985155 C3.41980316,5.23663768 4.19655211,5.07633514 4.89740311,5.12255445 C6.58492755,5.23380214 8.04126095,6.27482343 9.55279287,7.03342493 C10.1215077,7.31877478 10.7238709,7.57123237 11.3591264,7.60667662 C12.5107338,7.67094887 13.553929,7.02378409 14.3746288,6.2762412",
    id: "Stroke-7",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6189324,4.18611732 C20.6189324,4.18611732 17.1110857,4.15010596 14.9727104,4.86003069 C14.9727104,4.86003069 17.8798007,5.20530496 18.9916159,9.60568514 C20.1035257,14.0060653 19.5988941,19.8312099 19.3696879,20.4599437 C19.1404818,21.0884884 18.5654343,21.2141973 18.1463414,21.2141973 C17.7272486,21.2141973 16.6795165,20.5436866 16.8471915,19.5379205 C17.0148664,18.5320599 17.7958687,12.9894297 17.7958687,12.9894297 C17.7958687,12.9894297 16.1673235,12.04614 15.6481361,10.3439653 C15.1289487,8.64179054 14.0811221,3.61258208 14.0811221,3.61258208",
    id: "Stroke-9",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3828783,13.2256018 C9.95839798,14.7434664 7.84242343,15.4784384 5.65660007,14.8671905 C3.4706822,14.2559426 2.04279871,12.5299493 2.46727907,11.0120847 C2.89175942,9.49412554 5.00782849,8.75915355 7.19365185,9.37040148 C9.37947521,9.98174393 10.8073587,11.7076427 10.3828783,13.2256018 Z",
    id: "Stroke-11",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6717302,29.8891921 C20.6717302,29.8891921 21.9430918,29.6286059 22.406041,30.1406099 C22.406041,30.1406099 23.6162495,24.2316279 23.1971567,21.2142351",
    id: "Stroke-13",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.370731,8.05507948 C26.370731,8.05507948 27.5442665,11.617274 30.5673304,12.2877847",
    id: "Stroke-15",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7245752,0.0505860356 C22.4197556,0.0249716566 23.8927241,0.526295149 25.1604941,1.64775126 C26.3064304,2.66136234 27.2811946,3.9473743 28.7051083,4.59510618 C29.3115358,4.87100423 30.0138046,5.00918955 30.6466026,4.80058832 C31.6057713,4.48433108 32.3459418,3.55285615 33.2194772,3.04690128 C34.3507632,2.39179699 35.6277014,1.95540737 36.9484015,2.00446221 C39.5501041,2.10087057 41.3285548,4.09038004 41.3434904,6.63017332 C41.3594622,9.38149789 39.3587051,11.2989846 38.8708032,11.7429357",
    id: "Stroke-17",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6800748,9.61462655 C38.604839,8.55479617 39.2580529,6.9426971 38.3563511,5.78986101 C37.9237422,5.23664713 37.1468988,5.07634459 36.4461423,5.1225639 C34.7585233,5.23381159 33.3021899,6.27483288 31.790658,7.03333986 C31.2219432,7.31878424 30.6196744,7.57124182 29.9844189,7.60668607 C28.8327171,7.67095832 27.7895219,7.02379355 26.9689166,6.27625065",
    id: "Stroke-19",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7245752,4.18611732 C20.7245752,4.18611732 24.2324219,4.15010596 26.3707027,4.86003069 C26.3707027,4.86003069 23.4637069,5.20530496 22.3517971,9.60568514 C21.2399819,14.0060653 21.7446135,19.8312099 21.9737251,20.4599437 C22.2029313,21.0884884 22.7780733,21.2141973 23.1971662,21.2141973 C23.616259,21.2141973 24.6638965,20.5436866 24.4963161,19.5379205 C24.3286412,18.5320599 23.5476389,12.9894297 23.5476389,12.9894297 C23.5476389,12.9894297 25.1761841,12.04614 25.6953715,10.3439653 C26.2145589,8.64179054 27.2623855,3.61258208 27.2623855,3.61258208",
    id: "Stroke-21",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9605725,13.2256018 C31.3850529,14.7434664 33.501122,15.4784384 35.6869453,14.8671905 C37.8727687,14.2559426 39.3006522,12.5299493 38.8761718,11.0120847 C38.4516914,9.49412554 36.3357169,8.75915355 34.149799,9.37040148 C31.9639757,9.98174393 30.5360922,11.7076427 30.9605725,13.2256018 Z",
    id: "Stroke-23",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6395069,16.3004804 C19.6395069,18.1693849 19.6434069,19.684603 19.6481069,19.684603 C19.6529069,19.684603 19.6568069,18.1693849 19.6568069,16.3004804 C19.6568069,14.4315759 19.6529069,12.9164523 19.6481069,12.9164523 C19.6434069,12.9164523 19.6395069,14.4315759 19.6395069,16.3004804 Z",
    id: "Stroke-25",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6921355,16.3335239 C21.6921355,18.2024284 21.6960355,19.7176465 21.7007355,19.7176465 C21.7055355,19.7176465 21.7094355,18.2024284 21.7094355,16.3335239 C21.7094355,14.4645249 21.7055355,12.9494013 21.7007355,12.9494013 C21.6960355,12.9494013 21.6921355,14.4645249 21.6921355,16.3335239 Z",
    id: "Stroke-27",
    stroke: "#EE7330"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Day-",
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: 5.29300821,
    fontWeight: "bold",
    letterSpacing: 0.000945180039,
    fill: "#222456"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.5292215,
    y: 38.1072206
  }, "Day ")), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: 9.45180038,
    fontWeight: "bold",
    fill: "#222456"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.7771008,
    y: 38.1072206
  }, "1")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanAtom);
export default __webpack_public_path__ + "static/media/womanAtom.9dc27345.svg";
export { ForwardRef as ReactComponent };